// This list comes from Phase 2 ticket:
// https://gitlab.com/grit-digital-health/YOU-Frontend/-/issues/2415

export const studentMappedSubdomain = [
  {
    name: 'Happy',
    searchTerm: 'Happy',
    subdomains: [4, 15]
  },
  {
    name: 'Tired',
    searchTerm: 'Sleep',
    subdomains: [1, 114]
  },
  {
    name: 'Sick',
    searchTerm: 'Sickness',
    subdomains: [1, 114]
  },
  {
    name: 'Social',
    searchTerm: 'Making Friends',
    subdomains: [17, 15]
  },
  {
    name: 'Thinking about my future',
    searchTerm: 'Future Planning',
    subdomains: [12, 14, 9, 20]
  },
  {
    name: 'Sad',
    searchTerm: 'Sadness',
    subdomains: [7, 3, 18]
  },
  {
    name: 'Self-discovery',
    searchTerm: 'Personality',
    subdomains: [19, 16, 20]
  },
  {
    name: 'Mindful',
    searchTerm: 'Mindfulness',
    subdomains: [18, 20]
  },
  {
    name: 'Overwhelmed',
    searchTerm: 'Overwhelmed',
    subdomains: [3, 18]
  },
  {
    name: 'Relaxed',
    searchTerm: 'Relaxed',
    subdomains: [18]
  },
  {
    name: 'Angry',
    searchTerm: 'Anger',
    subdomains: [2]
  },
  {
    name: 'Self-conscious',
    searchTerm: 'Self Confidence',
    subdomains: [5, 19]
  },
  {
    name: 'Anxious',
    searchTerm: 'Managing Anxiety',
    subdomains: [3]
  },
  {
    name: 'Partying too much',
    searchTerm: 'Substance Use',
    subdomains: [6, 8, 20]
  },
  {
    name: 'Lonely',
    searchTerm: 'Loneliness',
    subdomains: [17, 15, 7]
  },
  {
    name: 'Falling behind academically',
    searchTerm: 'Grades',
    subdomains: [10, 11]
  },
  {
    name: 'Stressed about money',
    searchTerm: 'Money',
    subdomains: [113, 3, 12]
  }
]

export const staffMappedSubdomain = [
  {
    name: 'Happy',
    searchTerm: 'Happy',
    subdomains: [75, 84]
  },
  {
    name: 'Tired',
    searchTerm: 'Sleep',
    subdomains: [74, 78]
  },
  {
    name: 'Social',
    searchTerm: 'Involvement',
    subdomains: [86, 83, 85]
  },
  {
    name: 'Thinking about my future',
    searchTerm: 'Future Planning',
    subdomains: [69, 70, 72]
  },
  {
    name: 'Stressed',
    searchTerm: 'Stress',
    subdomains: [80, 77, 82]
  },
  {
    name: 'Mindful',
    searchTerm: 'Mindfulness',
    subdomains: [82, 84, 73]
  },
  {
    name: 'Overwhelmed',
    searchTerm: 'Overwhelmed',
    subdomains: [77, 82]
  },
  {
    name: 'Relaxed',
    searchTerm: 'Relaxed',
    subdomains: [82]
  },
  {
    name: 'Overindulging',
    searchTerm: 'Substance Use',
    subdomains: [79, 69]
  },
  {
    name: 'Self-conscious',
    searchTerm: 'Self Confidence',
    subdomains: [76, 87, 82]
  },
  {
    name: 'Anxious',
    searchTerm: 'Anxiety',
    subdomains: [77, 82]
  },
  {
    name: 'Lonely',
    searchTerm: 'Making Friends',
    subdomains: [86, 82]
  },
  {
    name: 'Stressed about money',
    searchTerm: 'Finances',
    subdomains: [71, 77]
  }
]
